import {ExtraTermsChip, SectionFilterDropdownChip, useFilterStore} from '@modules/catalog'
import {MyFilterChip, SelectionFilterChip, FilterChipsSection} from '@modules'
import {PrimaryIconButton, SecondaryButton} from 'centric-ui-components'
import {_, React, observer, observable, computed, IDisposer, action, useLocalStore, useEffect, useLayoutEffect, classNames, useAsObservableSource} from '@api'
import {useVipLocalStore, VipLocalStore} from '@modules'
import {StoresInstance} from '@stores'
import * as css from './CatalogFilterChips.css'

/// region Store

export class CatalogFiltersChipsStore extends VipLocalStore {
  constructor(stores: StoresInstance, public props: Omit<MyProps, 'className'>) {
    super(stores)
  }

  registerEffects = () => {
    const { catalog } = this,
      _toDispose: Array<IDisposer> = []

    catalog.componentStores.filterChips = this

    return () => {
      _toDispose.forEach(d => d())
      catalog.componentStores.filterChips = null
    }
  }

  @computed get filtersNoSeasons() {
    const {filter: {filtersWithSelections}, catalog: {isSeasonSelectorField}} = this
    return filtersWithSelections.filter(f => !isSeasonSelectorField(f.group))
  }

  @computed get filtersBySectionDict() {
    const {filtersNoSeasons, catalog} = this
    return _.groupBy(filtersNoSeasons, f => f.field?.section ?? catalog.id)
  }

  @computed get myCatalogsFilters() { return this.filtersBySectionDict[this.catalog.id]}

  @computed get otherFiltersBySection() {
    const {catalog: {sections}, catalog, filtersBySectionDict} = this
    return sections.map(s => ({section: s, filters: filtersBySectionDict[s.id]})).filter(v => v.filters && v.section.id !== catalog.id)
  }
}

export const CatalogFiltersChipsStoreContext = React.createContext<CatalogFiltersChipsStore>(null)
export const useCatalogFiltersChipsStore = () => React.useContext(CatalogFiltersChipsStoreContext)

/// endregion

/// region Components

interface MyProps {
  className?: string
}

export const CatalogFilterChips = observer<{}>(function CatalogFiltersChips() {
  const filter = useFilterStore(),
    obsProps = useAsObservableSource({filter}),
    store = useVipLocalStore((stores) => new CatalogFiltersChipsStore(stores, obsProps)),
    {
      otherFiltersBySection, myCatalogsFilters,
      filter: {hasFilterTerms, state: {extraTerms}, resetFilterExcludeSeason, hasLoaded}, strings,
      catalog: {isShowingAssortment, settings: {freezeIds}}} = store

  useEffect(() => store.registerEffects(), [])

  return !hasFilterTerms ? null : (
    <CatalogFiltersChipsStoreContext.Provider value={store}>
      <div className={css.root}>
      <FilterChipsSection data-type='filters'>
      {hasLoaded &&
	   <div className={css.chips} data-gradiants-nested='2'>
       {(otherFiltersBySection ?? []).map(({section, filters}) => (
         <SectionFilterDropdownChip
           className={css.chip}
           filters={filters}
           section={section}
           key={section.id} />
       ))}

       {(myCatalogsFilters ?? []).map((f, i) => (
         <div className={css.chip} key={i}>
           <MyFilterChip filterKey={f.group}/>
         </div>))}


       {!_.isEmpty(extraTerms) && <div className={css.chip}>
	       <ExtraTermsChip/>
       </div>}

         {freezeIds.length > 0 && !isShowingAssortment && <div className={css.chip}><SelectionFilterChip/></div>}

	     <PrimaryIconButton showOnHover icon='clean' tooltipStyle='mui' tooltip={strings.clearFilters} onClick={resetFilterExcludeSeason}/>
	   </div>}
    </FilterChipsSection>
      </div>

    </CatalogFiltersChipsStoreContext.Provider>)
})

/// endregion


// WEBPACK FOOTER //
// ./src/modules/catalog/FilterChipsToolbar/CatalogFilters/CatalogFilterChips.tsx